// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1-khP","col":"styles_col__3IoSV"};